<!--
 * @Description: 发票管理
 *               工业只有开票备案
                 服务商有未开票 开票记录（查看、审核） 发票备案
                 供应商有未开票（渠道服务费一种类型） 开票记录（补充、上传、审核） 
 * @Date: 2025-06-11 16:21:13
-->
<template>
  <div>
    <BaseTabs style="margin: 10px 0" v-model="tab" v-if="tabs.length > 1">
      <BaseTabPane
        v-for="item in tabs"
        :label="item.label"
        :name="item.value"
        :key="item.value"
      ></BaseTabPane>
    </BaseTabs>
    <component :is="curCmopt" />
  </div>
</template>
<script lang="tsx" setup>
import { ref, onMounted, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';

import { TABS } from '@V/invoice/src/constants';
import { RouteQuery } from '@V/invoice/src/types';
import { useRoute } from 'vue-router';

const route = useRoute();

const routeQuery = route.query as RouteQuery;

const tab = ref();

const curCmopt = computed(() => {
  return TABS[tab.value]?.cmpt;
});
/* 对应角色设置tab */
const tabs = computed(() => {
  return [TABS[1], TABS[2]]; // TABS[5] 去掉代缴税金
});

onMounted(async () => {
  tab.value = +routeQuery.tab ? +routeQuery.tab : tabs.value[0].value;
});
</script>
